<template>
  <div class="switch-wrapper">
    <h2 class="title">选择权证</h2>

    <div class="search-area">
      <a-form layout="inline">
        <a-form-item label="权证编号">
          <a-input-search
            placeholder="权证编号"
            v-model="queryParam.certificateNumber"
            style="width: 250px"
            @search="onSearch"
          />
        </a-form-item>

        <a-form-item label="权证地址">
          <a-input-search
            placeholder="权证地址"
            v-model="queryParam.certificateAddress"
            style="width: 250px"
            @search="onSearch"
          />
        </a-form-item>
        <a-form-item label="权利人名称">
          <a-input-search
            placeholder="权利人名称"
            v-model="queryParam.obligeeName"
            style="width: 250px"
            @search="onSearch"
          />
        </a-form-item>

        <a-button type="primary" style="margin-top: 4px" @click="reset"
          >重置</a-button
        >
      </a-form>
    </div>

    <a-table
      :pagination="table.pagination"
      :loading="table.loading"
      :columns="table.columns"
      :data-source="table.data"
      :row-key="(record) => record.webId"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :scroll="{ x: 1200 }"
      @change="handleTableChange"
    >
      <span slot="index" slot-scope="text, record, index">
        {{
          (table.pagination.pageNo - 1) * table.pagination.pageSize + index + 1
        }}
      </span>

      <span slot="propertyType" slot-scope="propertyType">
        {{ propertyType | propertyTypeText }}
      </span>

      <span slot="auditStatus" slot-scope="auditStatus">
        <a-badge
          v-if="auditStatus != null"
          :status="auditStatus | statusTypeFilter"
          :text="auditStatus | statusFilter"
        />
      </span>
    </a-table>

    <!-- 按钮 -->
    <div class="btn-row">
      <a-button class="btn-cancel" @click="closeMoudle">取消</a-button>
      <a-button type="primary" @click="selectData">确定</a-button>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "权证编号",
    dataIndex: "certificateNumber",
    width: 280,
  },
  {
    title: "权证类型",
    dataIndex: "propertyType",
    width: 100,
    scopedSlots: { customRender: "propertyType" },
  },
  {
    title: "权证地址",
    dataIndex: "certificateAddress",
    width: 300,
  },
  {
    title: "权利人名称",
    dataIndex: "obligeeName",
    width: 280,
  },
  {
    title: "状态",
    dataIndex: "auditStatus",
    width: 180,
    scopedSlots: { customRender: "auditStatus" },
  },
  {
    title: "提交时间",
    dataIndex: "submitTime",
    width: 200,
  },
];
const statusMap = {
  1: {
    status: "warning",
    text: "编辑中",
  },
  2: {
    status: "processing",
    text: "审核中",
  },
  3: {
    status: "success",
    text: "审核通过",
  },
};
const propertyType = {
  1: "产权",
  2: "使用权",
  3: "其他",
};
import { listWarrant } from "@/api/property/Property.js";
export default {
  data() {
    return {
      //输入框
      queryParam: {
        auditStatus: 3,
        certificateNumber: undefined,
        certificateAddress: undefined,
        obligeeName: undefined,
      },
      table: {
        data: [],
        loading: false,
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
        columns,
      },
      selectedRows: [],
      selectedRowKeys: [],
    };
  },
  mounted() {
    this.getTableDetails({
      pageSize: 5,
      page: 1,
      auditStatus: this.queryParam.auditStatus,
      certificateNumber: this.queryParam.certificateNumber,
      certificateAddress: this.queryParam.certificateAddress,
      obligeeName: this.queryParam.obligeeName,
    });
  },

  filters: {
    statusFilter(type) {
      return statusMap[type].text;
    },
    statusTypeFilter(type) {
      return statusMap[type].status;
    },
    propertyTypeText(type) {
      return propertyType[type] || "-";
    },
  },

  methods: {
    /**
     * 分页,查询
     * 根据条件筛选并重置分页,可复制
     */
    onSearch() {
      const pager = { ...this.table.pagination };
      pager.current = 1;
      this.handleTableChange(pager);
    },

    /**
     * 分页,点击下一页
     * 表格变化回调，用于分页,筛选和排序,可复制 参数略有修改
     */
    handleTableChange(pagination) {
      //设置重置按钮分页回到第一页
      const pager = { ...this.table.pagination };
      pager.current = pagination.current;
      this.table.pagination = pager;
      this.getTableDetails({
        pageSize: pagination.pageSize,
        page: pagination.current,
        auditStatus: this.queryParam.auditStatus,
        certificateNumber: this.queryParam.certificateNumber,
        certificateAddress: this.queryParam.certificateAddress,
        obligeeName: this.queryParam.obligeeName,
      });
    },

    /**
     * 分页,默认第一页+查询
     * 获取选择层级下角色列表
     */
    getTableDetails(params = {}) {
      this.table.loading = true;
      listWarrant({
        page: 1,
        pageSize: 5,
        ...params,
      }).then((res) => {
        const pagination = { ...this.table.pagination };
        pagination.total = res.total;
        pagination.pageSize = res.pageSize;
        pagination.pageNo = res.pageNo;
        pagination.current = res.pageNo;
        if (res.pageNo != 1 && res.data.length == 0) {
          //用于新增或删除后自动刷新，避免页面为空现象
          this.getTableDetails({
            pageSize: res.pageSize,
            page: res.pageNo - 1,
            auditStatus: this.queryParam.auditStatus,
            certificateNumber: this.queryParam.certificateNumber,
            certificateAddress: this.queryParam.certificateAddress,
            obligeeName: this.queryParam.obligeeName,
          });
        }
        if (res.pageNo == 1 || res.data.length != 0) {
          this.table.data = res.data;
          this.table.loading = false;
          this.table.pagination = pagination;
        }
      });
    },

    //重置表格查询
    reset() {
      //重置
      this.queryParam.auditStatus = 3;
      this.queryParam.certificateNumber = undefined;
      this.queryParam.certificateAddress = undefined;
      this.queryParam.obligeeName = undefined;
      this.onSearch();
    },

    /**
     * 刷新当前页(用于新增或删除后自动刷新)
     */
    refreshCurrentPage() {
      const pager = { ...this.table.pagination };
      if (pager.current == undefined || pager.current == 1) {
        this.onSearch();
      } else {
        this.handleTableChange(pager);
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
    },

    closeMoudle() {
      this.$emit("closeMoudle");
    },
    selectData() {
      if (!this.selectedRowKeys?.length) {
        this.$notification.warning({
          message: "请选择权证",
          description: `构建房源失败`,
        });
      } else {
        this.$emit("listSelectRight", {
          //选择的权证webId列表
          selectRightList: this.selectedRowKeys,
        });
      }
    },
  },
};
</script>

<style scoped>
.switch-wrapper {
  padding: 10px 20px 0 20px;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* 按钮行 */
.btn-row {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-cancel {
  border: 1px solid #d9d9d9;
}

/* 输入框高度统一 */
.password-item /deep/ .ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
